/// <reference path="../declarations/global.d.ts" />

export function getConfig() {
  return typeof window !== 'undefined' ? window.Datarouter?.Config : undefined;
}
